import { FieldMetadata, useInputControl } from '@conform-to/react'
import { z } from 'zod'

import { IconOfficeChair } from '~/components'
import { MultiSelect } from '~/components/ui/input/select'

export const officeTypeMultiSelectFormSchema = z.object({
  officeTypes: z.array(z.string()),
})

export const partialOfficeTypeMultiSelectFormSchema =
  officeTypeMultiSelectFormSchema.partial()

type OfficeType = z.infer<typeof officeTypeMultiSelectFormSchema>['officeTypes']

type Options = React.ComponentProps<typeof MultiSelect>['options']

export const useOfficeTypeForm = (
  meta: FieldMetadata<OfficeType>,
  changeWatchedOfficeTypes?: (officeTypes: string[]) => void,
) => {
  const control = useInputControl<OfficeType>({
    ...meta,
    initialValue: Array.isArray(meta?.initialValue)
      ? meta.initialValue.filter((val): val is string => val !== undefined)
      : [],
  })

  const value = Array.isArray(control.value) ? control.value : []

  const onChange = (officeTypes: string[]) => {
    changeWatchedOfficeTypes?.(officeTypes)
    control.change(officeTypes)
  }

  return { value, onChange, name: meta.name }
}

type Props = {
  name: string
  options: Options
  ariaLabel?: string
  value: string[]
  onChange: (value: string[]) => void
}

export const OfficeTypeMultiSelectForm = ({
  name,
  ariaLabel,
  options,
  value,
  onChange,
}: Props) => {
  return (
    <MultiSelect
      aria-label={ariaLabel}
      closeMenuOnSelect={false}
      hasSelectAllOption
      hideSelectedOptions={false}
      isClearable
      name={name}
      onChange={onChange}
      options={options}
      placeholder="オフィスタイプを選択"
      placeholderIcon={<IconOfficeChair />}
      selectAllOptionLabel="全てのオフィスタイプを選択"
      value={value}
    />
  )
}
